// HistoricoIncidencias — sección que muestra los últimos 20 eventos del log de alertas.
// Cuándo cayó algo, qué cayó, cuándo se recuperó, a quién se le mandó WhatsApp.
// Datos: tabla sistema_alertas_log.

import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export default function HistoricoIncidencias() {
  const [eventos, setEventos] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancel = false
    async function cargar() {
      const { data } = await supabase
        .from('sistema_alertas_log')
        .select('id, fecha, evento, estado_anterior, estado_nuevo, destinatarios_count, servicios_problema')
        .order('fecha', { ascending: false })
        .limit(20)
      if (!cancel) {
        setEventos(data || [])
        setLoading(false)
      }
    }
    cargar()
    return () => { cancel = true }
  }, [])

  function icono(evento) {
    if (evento === 'caida') return '🔴'
    if (evento === 'recuperacion') return '✅'
    if (evento === 'recordatorio_caida') return '⏰'
    return '🔔'
  }
  function tituloEvento(evento) {
    if (evento === 'caida') return 'Caída detectada'
    if (evento === 'recuperacion') return 'Servicios recuperados'
    if (evento === 'recordatorio_caida') return 'Recordatorio (sin resolver)'
    return evento
  }
  function fmtFecha(ts) {
    if (!ts) return ''
    return new Date(ts).toLocaleString('es-UY', {
      day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit'
    })
  }

  return (
    <section className="infra-card">
      <h2>📋 Histórico de incidencias</h2>
      <p>Últimas 20 alertas registradas. Cada vez que un servicio cae o se recupera queda log acá.</p>

      {loading && <div className="hi-empty">Cargando…</div>}
      {!loading && eventos.length === 0 && (
        <div className="hi-empty">🎉 Sin incidencias registradas todavía.</div>
      )}

      {!loading && eventos.length > 0 && (
        <div className="hi-lista">
          {eventos.map(ev => (
            <div key={ev.id} className={`hi-row hi-row-${ev.evento}`}>
              <div className="hi-icono">{icono(ev.evento)}</div>
              <div className="hi-body">
                <div className="hi-titulo">{tituloEvento(ev.evento)}</div>
                <div className="hi-meta">
                  <span>{fmtFecha(ev.fecha)}</span>
                  <span>•</span>
                  <span>{ev.estado_anterior} → <strong>{ev.estado_nuevo}</strong></span>
                  {ev.destinatarios_count > 0 && (
                    <>
                      <span>•</span>
                      <span>📱 {ev.destinatarios_count} notif</span>
                    </>
                  )}
                </div>
                {ev.servicios_problema?.length > 0 && (
                  <div className="hi-servicios">
                    {ev.servicios_problema.slice(0, 4).map((s, i) => (
                      <span key={i} className="hi-srv">{s.nombre || s.id}</span>
                    ))}
                    {ev.servicios_problema.length > 4 && (
                      <span className="hi-srv hi-srv-mas">+{ev.servicios_problema.length - 4}</span>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      <style>{`
        .hi-empty { padding: 24px; text-align: center; color: #94A3B8; font-size: 13px; }
        .hi-lista { display: flex; flex-direction: column; gap: 6px; margin-top: 10px; }
        .hi-row {
          display: flex; gap: 12px; align-items: flex-start;
          padding: 10px 12px; background: #F8FAFC;
          border-radius: 8px; border-left: 3px solid #94A3B8;
        }
        .hi-row-caida { border-left-color: #DC2626; }
        .hi-row-recuperacion { border-left-color: #16A34A; }
        .hi-row-recordatorio_caida { border-left-color: #D97706; }
        .hi-icono { font-size: 18px; line-height: 1; flex-shrink: 0; }
        .hi-body { flex: 1; min-width: 0; }
        .hi-titulo { font-size: 13px; font-weight: 700; color: #1A3461; }
        .hi-meta { font-size: 11px; color: #64748B; display: flex; gap: 6px; flex-wrap: wrap; margin-top: 2px; }
        .hi-meta strong { color: #1A3461; }
        .hi-servicios { display: flex; gap: 4px; flex-wrap: wrap; margin-top: 6px; }
        .hi-srv {
          font-size: 10px; padding: 2px 8px;
          background: #fff; border: 1px solid #E2E8F0;
          border-radius: 999px; color: #475569; font-weight: 600;
        }
        .hi-srv-mas { background: #F1F5F9; color: #64748B; }
      `}</style>
    </section>
  )
}
